export const REQUEST_GET_LIBRARY = 'REQUEST_GET_LIBRARY';
export const SUCCESS_GET_LIBRARY = 'SUCCESS_GET_LIBRARY';
export const FAILURE_GET_LIBRARY = 'FAILURE_GET_LIBRARY';
